import branch from "branch-sdk";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import config from "config";
import {
  BranchReduxActions,
  NavigationReduxAction,
  OrderModules,
  RootState,
} from "gyg_common";
import { Screens } from "navigation/const";
import { clearAndNavigateToOrderStatusScreen } from "navigation/utils";
import { OrderSetupContainer } from "views/containers/OrderSetup/OrderSetupContainer";

import { handleBranchDeeplink } from "../../../modules/branch";

const BranchAndModalsContainer: React.FC = () => {
  const { getOrderByIdSuccess } = useSelector(
    (state: RootState) => state.order
  );
  const { paymentResponse } = useSelector((state: RootState) => state.checkout);
  const branchState = useSelector((s: RootState) => s.branch);
  const { showOrderSetup, orderSetupNavigation: setupNavigation } = useSelector(
    (state: RootState) => state.navigation
  );

  const [showSetupOrder, setSetupOrder] = useState(false);
  const [orderSetupNavigation, setOrderSetupNavigation] = useState<string>(
    Screens.Menu
  );

  const dispatch = useDispatch();
  const history = useHistory();

  const onCloseModal = useCallback(() => {
    setSetupOrder(false);
  }, []);

  const onConfirmClick = useCallback(() => {
    history.push(orderSetupNavigation);
    setSetupOrder(false);
  }, [history, orderSetupNavigation]);

  useEffect(() => {
    branch.init(
      config.branchKey,
      undefined,
      handleBranchDeeplink(history, dispatch)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //
  //Branch actions
  //
  useEffect(() => {
    if (
      getOrderByIdSuccess &&
      paymentResponse &&
      !!branchState.requestedOrderData
    ) {
      if (
        OrderModules.OrderUtils.isOlderThanActiveOrderThreshold(paymentResponse)
      ) {
        history.push(Screens.OrderDetails);
      } else {
        clearAndNavigateToOrderStatusScreen(history, dispatch);
      }
      dispatch(BranchReduxActions.clearRequestedOrderData());
    }
  }, [
    dispatch,
    getOrderByIdSuccess,
    history,
    paymentResponse,
    branchState.requestedOrderData,
  ]);

  //
  // Change OrderSetup
  //
  useEffect(() => {
    if (showOrderSetup) {
      setSetupOrder(true);
    }

    return () => {
      dispatch(NavigationReduxAction.setOpenOrderSetup(false));
    };
  }, [showOrderSetup, dispatch]);

  useEffect(() => {
    setOrderSetupNavigation(setupNavigation);
  }, [setupNavigation]);

  return (
    <>
      <OrderSetupContainer
        onConfirmClick={onConfirmClick}
        onCloseModal={onCloseModal}
        isVisible={showSetupOrder}
      />
    </>
  );
};
export default BranchAndModalsContainer;
